<template>
    <div :id="modalId" uk-modal class="employee-certification-form">
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title uk-margin-medium-bottom">Update Certification</h2>
            <div class="uk-grid">
                <div class="uk-form-controls uk-width-2-3">
                    <label for="employee-certification-modal-certifications" class="uk-form-label">Certification</label>
                    <select id="employee-certification-modal-certifications" class="uk-select " v-model="certificationId">
                        <option v-for="val in certificationOptions" :value="val.id" >{{val.name}}</option>
                    </select>
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <label class="uk-form-label">Completion Date</label>
                    <datepicker ref="certifiedDate" type="date" v-model="certified" v-on:input="certifiedDateSet" input-class="uk-input" :use-utc=true :typeable=true :clear-button=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                </div>
            </div>
			<div class="uk-form-label uk-margin-small-top">Documents</div>
			<div class="employee-documents" v-for="doc in documents">
				<a :href="doc.url" target="_blank" v-if="renamingDocId!=doc.id" >{{ doc.name }}</a>
				<i class="fas fa-edit" @click="renameDoc(doc.id)" v-if="renamingDocId!=doc.id"></i>
				<input class="uk-input uk-width-5-6" type="text" v-model="doc.name" v-if="renamingDocId==doc.id" />
				<i class="fas fa-save" @click="updateDocName(doc.id, doc.name)" v-if="renamingDocId==doc.id"></i>
			</div>
            <div class="uk-margin-medium-bottom"></div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>

<script>
    import EventBus from "../../events";
	import Datepicker from "vuejs-datepicker";
    export default {
        name: "EmployeeCertificationForm",
		components:{
			Datepicker
		},
        props:{
            uid:Number,
            modalId:String,
            tableRef:String
        },

        data(){
            return {
                personCertificationId:null,
                certificationOptions:[],
                certificationId:0,
                certified:"",
                certifiedDateString:"",
                docId: null,
                updateAfter: null,
				documents:[],
				renamingDocId:null
            }
        },

        mounted(){
            this.loadCertifications();
        },
        methods:{
            loadCertifications(){
                axios.get("/api/certs/list/all?sort=name&dir=asc")
                    .then((pack) => this.updateCertificationData(pack));
            },
            loadForm(id){
                this.personCertificationId = id;
                axios.get("/api/employee/"+this.uid+"/certification/" + id)
                    .then((pack) => this.formLoaded(pack));
            },
            formLoaded(pack){
                let dt = pack.data.data;
                this.certificationId = dt.certification_id;
                this.certified = dt.certified;
				this.documents = dt.documents;
				this.renamingDocId = null;
                this.$refs.certifiedDate.value = this.certified;
            },
            updateCertificationData(pack){
                let dt = pack.data.data;
                this.certificationOptions = dt;
            },
            submitForm(){
                if(!this.certificationId){
                    return;
                }
                let formData = new FormData();
                formData.append("certification_id", this.certificationId);
                formData.append("certified", this.certifiedDateString);

                if(this.docId){
                    formData.append("doc_id", this.docId);
                }

                axios.post("/api/employee/"+this.uid+"/certification" + (this.personCertificationId ? "/"+this.personCertificationId:""), formData)
                    .then((pack) => this.dataUpdated(pack));
            },
            dataUpdated(pack){
                if(this.$root.$refs[this.tableRef]){ //if the sidebar is closed, it won't be there
                    this.$root.$refs[this.tableRef].loadCertifications();
                }
                let chosenCert = null;
                for(let i = 0; i < this.certificationOptions.length;++i){
                    if(this.certificationOptions[i].id == this.certificationId){
                        chosenCert = this.certificationOptions[i];
                        break;
                    }
                }
                if(pack.data.success){
                    EventBus.fireEvent("message", chosenCert.name + " added.");
                } else {
                    EventBus.fireEvent("error", chosenCert.name + " could not be added.");
                }
                this.personCertificationId = null;
                this.certificationId = 0;
                this.certified = "";
                this.docId = null;
				this.documents = [];
                if(this.updateAfter){
                    this.updateAfter.loadFiles();
                }
            },
            cancel(){
                if(this.personCertificationId){
                    this.personCertificationId = null;
                    this.certificationId = 0;
                    this.certified = "";
                    this.docId = null;
                    this.updateAfter = null;
					this.documents = [];
                }

            },
            certifiedDateSet(val){
                this.certifiedDateString = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            loadDoc(id, caller){
                this.personCertificationId = null;
                this.docId = id;
                this.updateAfter = caller;

                axios.get("/api/employee/"+this.uid+"/file/" + this.docId).then(
					(pack) => this.loadExternalDoc(pack),
					(pack) => this.loadExternalDoc(pack)
				)
            },
			renameDoc(id){
				this.renamingDocId = id;
			},
			updateDocName(id, name){
				this.renamingDocId = null;
				axios.put("/api/employee-file/"+id+"/rename",{
					name: name
				}).then(
					(pack) => this.updateDocs(pack),
					(pack) => this.updateDocs(pack)
				)
			},
			updateDocs(pack){
            	if(pack.data.success){
            		let doc = pack.data.data;
            		for(let i = 0; i < this.documents.length;++i){
            			if(this.documents[i].id == doc.id){
            				this.documents[i] = doc;
            				this.$forceUpdate();
            				break;
						}
					}
					if(this.updateAfter){
						this.updateAfter.loadFiles();
					}
				}
			},
			loadExternalDoc(pack){
				if(pack.data.success){
					this.documents = [pack.data.data];
				}
			}
        }
    }
</script>
